// Single place where GSAP is configured. Import gsap / ScrollTrigger / useGSAP from here
// so plugins are registered once and every animation shares the same defaults.
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { useGSAP } from '@gsap/react';

gsap.registerPlugin(ScrollTrigger, useGSAP);
gsap.defaults({ ease: 'power2.out', duration: 0.4 });

// Respect the OS "reduce motion" setting: callers skip their animation when this is true.
export const prefersReducedMotion = () =>
    typeof window !== 'undefined' &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

// Animations use `opacity`, not `autoAlpha`: autoAlpha sets visibility:hidden, and hidden
// elements can't receive focus (it broke auto-focusing the first OTP box).
// Clear inline styles afterwards: a leftover `transform` on a wrapper turns it into the
// containing block for `position: fixed` modals inside it.
export const CLEAR_PROPS = 'opacity,transform';

export { gsap, ScrollTrigger, useGSAP };
